import { useState } from 'react';
import { useAuth } from '../auth/AuthContext.jsx';

/**
 * Persistent banner shown at the top of every page while a superadmin is
 * "viewing as" another user. Click "Return" to swap back to the admin token.
 */
export default function ImpersonationBanner() {
  const { user, isImpersonating, stopImpersonation } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!isImpersonating) return null;

  return (
    <div className="bg-crimson text-white text-sm">
      <div className="max-w-6xl mx-auto px-4 py-2 flex items-center gap-3">
        <span className="text-base">👁</span>
        <span className="flex-1 truncate">
          Viewing as <b>{user.full_name}</b>
          <span className="opacity-80"> ({user.email}) — actions are logged under your admin account ({user.impersonator?.email})</span>
        </span>
        <button
          onClick={async () => { setBusy(true); await stopImpersonation(); setBusy(false); }}
          disabled={busy}
          className="bg-white text-crimson font-medium rounded px-3 py-1 text-xs hover:bg-white/90"
        >
          {busy ? 'Returning…' : 'Return to admin'}
        </button>
      </div>
    </div>
  );
}
